import {
  IconArrowsRightLeft,
  IconBarcode,
  IconBell,
  IconBrandMastercard,
  IconBuildingBank,
  IconChartBar,
  IconCreditCard,
  IconDatabaseDollar,
  IconFileInvoice,
  IconHome,
  IconLayout,
  IconPackage,
  IconSettings,
  IconSettingsFilled,
  IconSpeakerphone,
  IconTable,
  IconTableFilled,
  IconUser,
} from "@tabler/icons-react";
import { isEqual } from "lodash";
import { v4 as uuidv4 } from "uuid";
import RoutesString from "pages/routesString";

const menuForMaker = (pathname: string, t: (key: string) => string) => {
  const arrPath = pathname.split("/").slice(1);
  const getOpened = (root: string) => {
    return isEqual(arrPath[0], root);
  };

  return [
    {
      id: uuidv4(),
      label: t("DASHBOARD"),
      icon: IconHome,
      iconActive: IconHome,
      root: "",
      initiallyOpened: getOpened(""),
      link: RoutesString.Dashboard,
    },
    {
      id: uuidv4(),
      label: t("ACCOUNT_CARD"),
      icon: IconUser,
      iconActive: IconUser,
      root: "accounts",
      initiallyOpened:
        getOpened("accounts") ||
        getOpened("cards") ||
        getOpened("term-deposit"),
      links: [
        {
          id: uuidv4(),
          label: t("PAYMENT_SOURCE_ACCOUNT"),
          link: RoutesString.AccountsList,
          linkDetail: RoutesString.Accounts,
        },
        {
          id: uuidv4(),
          label: t("CARDS_LIST"),
          link: RoutesString.CardsList,
          linkDetail: RoutesString.Cards,
        },
      ],
    },

    {
      id: uuidv4(),
      label: t("TRANSFER_MONEY"),
      root: "transfer-money",
      initiallyOpened: getOpened("transfer-money"),
      icon: IconCreditCard,
      iconActive: IconCreditCard,
      links: [
        {
          id: uuidv4(),
          label: t("DOMESTIC_TRANSFER"),
          link: RoutesString.TransferByAccount,
        },

        {
          id: uuidv4(),
          label: t("BATCH_TRANSFER"),
          link: RoutesString.TransferByBatch,
        },
        {
          id: uuidv4(),
          label: t("INTERNATIONAL_TRANSFER"),
          link: RoutesString.TransInternational,
        },
      ],
    },
    {
      id: uuidv4(),
      label: t("MANAGE_PAYMENT"),
      root: "manage-payment",
      initiallyOpened: getOpened("manage-payment"),
      icon: IconTable,
      iconActive: IconTableFilled,
      links: [
        {
          id: uuidv4(),
          label: t("BILL_PAYMENT_LIST"),
          root: "bill_payment",
          icon: IconSettings,
          iconActive: IconSettingsFilled,
          link: RoutesString.BillPaymentList,
        },
        {
          id: uuidv4(),
          label: t("BILL_PAYMENT"),
          link: RoutesString.BillPayment,
        },
      ],
    },
    {
      id: uuidv4(),
      label: t("MANAGE_TRANSACTION"),
      root: "manage-transaction",
      initiallyOpened: getOpened("manage-transaction"),
      icon: IconArrowsRightLeft,
      iconActive: IconArrowsRightLeft,
      links: [
        {
          id: uuidv4(),
          label: t("VIEW_TRANSACTION"),
          link: RoutesString.TransactionList,
        },
        {
          id: uuidv4(),
          label: t("MANAGER_BENEFICIARY/TRANSACTION_TEMPLATE"),
          link: RoutesString.BeneficiaryTemplate,
        },
        // {
        //   id: uuidv4(),
        //   label: t("CARD"),
        //   link: RoutesString.CardTransactionList,
        // },
      ],
    },
    {
      id: uuidv4(),
      label: t("FOREIGN_EXCHANGE_TRANSACTION"),
      icon: IconDatabaseDollar,
      iconActive: IconDatabaseDollar,
      root: "foreign-currency",
      initiallyOpened: getOpened("foreign-currency"),
      // link: RoutesString.ForeignCurrencyExchangePage,
      links: [
        {
          id: uuidv4(),
          label: t("BUY_FOREIGN_CURRENCY"),
          link: RoutesString.ForeignCurrencyExchangePage,
        },
        {
          id: uuidv4(),
          label: t("SELL_FOREIGN_CURRENCY"),
          link: RoutesString.SellForeignCurrencyPage,
        },
      ],
    },
    {
      id: uuidv4(),
      label: t("GOV_PAYMENT"),
      icon: IconBuildingBank,
      iconActive: IconBuildingBank,
      root: "nop-nsnn",
      link: RoutesString.NopNsnnOverview,
      initiallyOpened:
        getOpened("nop-nsnn") ||
        getOpened("domestic-tax-payment") ||
        getOpened("customs-duty-payment") ||
        getOpened("registartion-free"),
      links: [
        {
          id: uuidv4(),
          label: t("DOMESTIC_TAX_PAYMENT"),
          link: RoutesString.DomesticTaxPaymentPage,
        },
        {
          id: uuidv4(),
          label: t("CUSTOMS_DUTY_PAYMENT"),
          link: RoutesString.CustomsDutyPaymentPage,
        },
        {
          id: uuidv4(),
          label: t("REGISTRATION_FEE"),
          link: RoutesString.RegistartionFreePage,
        },
      ],
    },
    {
      id: uuidv4(),
      label: t("CREDIT_AND_TRADE_FINANCE"),
      icon: IconBrandMastercard,
      iconActive: IconBrandMastercard,
      root: "credit",
      initiallyOpened: getOpened("credit"),
      links: [
        // {
        //   id: uuidv4(),
        //   label: t("ONLINE_LOAN_MANAGEMENT"),
        //   link: RoutesString.TransactionList,
        // },
        // {
        //   id: uuidv4(),
        //   label: "Mở tài khoản vay",
        //   link: RoutesString.MortgageLoanAccountPage,
        // },
        // {
        //   id: uuidv4(),
        //   label: t("TRADE_FINANCE"),
        //   link: RoutesString.TransactionList,
        // },
        {
          id: uuidv4(),
          label: t("LETTER_OF_CREDIT"),
          link: RoutesString.LetterOfCreditOpenedPage,
        },
        {
          id: uuidv4(),
          label: t("IMPORT_COLLECTION_DOCUMENTS"),
          link: RoutesString.ShippingDocumentsPage,
        },
        // ẨN: màn Bảo lãnh cũ — đã được thay bằng "Danh sách bảo lãnh" (AW122) ngay dưới.
        // Giữ lại code thay vì xoá để bật lại được nếu cần đối chiếu.
        // {
        //   id: uuidv4(),
        //   label: t("GUARANTEE"),
        //   link: RoutesString.GuaranteePage,
        // },
        {
          id: uuidv4(),
          label: t("GUARANTEE_LIST"),
          link: RoutesString.GuaranteeListAw122Page,
        },
        {
          id: uuidv4(),
          label: t("DISBURSEMENT"),
          link: RoutesString.Disbursement,
        },
        {
          id: uuidv4(),
          label: t("LOAN_MANAGEMENT"),
          link: RoutesString.LoanList,
        },
      ],
    },
    // {
    //   id: uuidv4(),
    //   label: "Thanh toán Quốc tế và TTTM",
    //   icon: IconBrandMastercard,
    //   iconActive: IconBrandMastercard,
    //   root: "letterCredit",
    //   initiallyOpened: getOpened("letterCredit"),
    //   links: [
    //     {
    //       id: uuidv4(),
    //       label: "Tra cứu LC đã mở",
    //       link: RoutesString.LetterOfCreditOpenedPage,
    //     },
    //     {
    //       id: uuidv4(),
    //       label: "Đăng ký phát hành LC",
    //       link: RoutesString.LetterOfCreditOnlinePage,
    //     },
    //   ],
    // },

    {
      id: uuidv4(),
      label: t("DEPOSIT_MENU"),
      icon: IconBrandMastercard,
      iconActive: IconBrandMastercard,
      root: "term-deposit",
      initiallyOpened: getOpened("term-deposit"),
      links: [
        {
          id: uuidv4(),
          label: t("TERM_DEPOSIT_LIST"),
          link: RoutesString.TermDepositList,
        },
        {
          id: uuidv4(),
          label: t("OPEN_TERM_DEPOSIT_ACCOUNT"),
          link: RoutesString.ListSavings,
        },
      ],
    },
    {
      id: uuidv4(),
      label: t("OTHERS"),
      icon: IconLayout,
      iconActive: IconLayout,
      root: "others",
      initiallyOpened: getOpened("others"),
      link: RoutesString.ConvenienceServicesPage,
    },
    {
      id: uuidv4(),
      label: t("SETTING"),
      root: "setting",
      icon: IconSettings,
      iconActive: IconSettingsFilled,
      initiallyOpened: getOpened("setting"),
      link: RoutesString.UserProfile,
    },
    // {
    //   id: uuidv4(),
    //   label: t("HELP"),
    //   root: "help",
    //   icon: IconHelpCircle,
    //   iconActive: IconHelpCircleFilled,
    //   initiallyOpened: getOpened("help"),
    // },
  ];
};

const menuForChecker = (pathname: string, t: (key: string) => string) => {
  const arrPath = pathname.split("/").slice(1);
  const getOpened = (root: string) => {
    return isEqual(arrPath[0], root);
  };

  return [
    {
      id: uuidv4(),
      label: t("DASHBOARD"),
      icon: IconHome,
      iconActive: IconHome,
      root: "",
      initiallyOpened: getOpened(""),
      link: RoutesString.Dashboard,
    },
    {
      id: uuidv4(),
      label: t("ACCOUNT_CARD"),
      icon: IconUser,
      iconActive: IconUser,
      root: "accounts",
      initiallyOpened:
        getOpened("accounts") ||
        getOpened("cards") ||
        getOpened("term-deposit"),
      links: [
        {
          id: uuidv4(),
          label: t("ACCOUNTS_LIST"),
          link: RoutesString.AccountsList,
          linkDetail: RoutesString.Accounts,
        },
        {
          id: uuidv4(),
          label: t("CARDS_LIST"),
          link: RoutesString.CardsList,
          linkDetail: RoutesString.Cards,
        },
      ],
    },

    {
      id: uuidv4(),
      label: t("MANAGE_TRANSACTION"),
      root: "manage-transaction",
      initiallyOpened: getOpened("manage-transaction"),
      icon: IconArrowsRightLeft,
      iconActive: IconArrowsRightLeft,
      links: [
        {
          id: uuidv4(),
          label: t("VIEW_TRANSACTION"),
          link: RoutesString.TransactionList,
        },
        {
          id: uuidv4(),
          label: t("MANAGER_BENEFICIARY/TRANSACTION_TEMPLATE"),
          link: RoutesString.BeneficiaryTemplate,
        },
      ],
    },
    // {
    //   id: uuidv4(),
    //   label: t("FOREIGN_CURRENCY_EXCHANGE"),
    //   icon: IconDatabaseDollar,
    //   iconActive: IconDatabaseDollar,
    //   root: "foreign-currency-exchange",
    //   initiallyOpened: getOpened("foreign-currency-exchange"),
    //   link: RoutesString.ForeignCurrencyExchangePage,
    // },
    // {
    //   id: uuidv4(),
    //   label: t("GOV_PAYMENT"),
    //   icon: IconBuildingBank,
    //   iconActive: IconBuildingBank,
    //   root: "Gov",
    //   initiallyOpened: getOpened(""),
    //   links: [
    //     {
    //       id: uuidv4(),
    //       label: "",
    //       link: RoutesString.TransactionList,
    //     },
    //   ],
    // },
    {
      id: uuidv4(),
      label: t("CREDIT_AND_TRADE_FINANCE"),
      icon: IconBrandMastercard,
      iconActive: IconBrandMastercard,
      root: "credit",
      initiallyOpened: getOpened("credit"),
      links: [
        {
          id: uuidv4(),
          label: t("LETTER_OF_CREDIT"),
          link: RoutesString.LetterOfCreditOpenedPage,
        },
        {
          id: uuidv4(),
          label: t("IMPORT_COLLECTION_DOCUMENTS"),
          link: RoutesString.ShippingDocumentsPage,
        },
        // ẨN: màn Bảo lãnh cũ — đã được thay bằng "Danh sách bảo lãnh" (AW122) ngay dưới.
        // Giữ lại code thay vì xoá để bật lại được nếu cần đối chiếu.
        // {
        //   id: uuidv4(),
        //   label: t("GUARANTEE"),
        //   link: RoutesString.GuaranteePage,
        // },
        {
          id: uuidv4(),
          label: t("GUARANTEE_LIST"),
          link: RoutesString.GuaranteeListAw122Page,
        },
        {
          id: uuidv4(),
          label: t("DISBURSEMENT"),
          link: RoutesString.Disbursement,
        },
        {
          id: uuidv4(),
          label: t("LOAN_MANAGEMENT"),
          link: RoutesString.LoanList,
        },
      ],
    },
    {
      id: uuidv4(),
      label: t("DEPOSIT_MENU"),
      icon: IconBrandMastercard,
      iconActive: IconBrandMastercard,
      root: "term-deposit",
      initiallyOpened: getOpened("term-deposit"),
      links: [
        {
          id: uuidv4(),
          label: t("TERM_DEPOSIT_LIST"),
          link: RoutesString.TermDepositList,
        },
        {
          id: uuidv4(),
          label: t("OPEN_TERM_DEPOSIT_ACCOUNT"),
          link: RoutesString.ListSavings,
        },
      ],
    },
    {
      id: uuidv4(),
      label: t("OTHERS"),
      icon: IconLayout,
      iconActive: IconLayout,
      root: "others",
      initiallyOpened: getOpened("others"),
      link: RoutesString.ConvenienceServicesPage,
    },
    {
      id: uuidv4(),
      label: t("SETTING"),
      root: "setting",
      icon: IconSettings,
      iconActive: IconSettingsFilled,
      initiallyOpened: getOpened("setting"),
      link: RoutesString.UserProfile,
    },
    {
      id: uuidv4(),
      label: t("ENTERPRISE_ADMINISTRATION"),
      icon: IconUser,
      iconActive: IconUser,
      root: "corporate-governance",
      initiallyOpened: getOpened("corporate-governance"),
      links: [
        {
          id: uuidv4(),
          label: t("ENTERPRISE_INFORMATION"),
          link: RoutesString.InfoBusinessPage,
        },
        {
          id: uuidv4(),
          label: t("MANAGE_REQUEST"),
          link: RoutesString.RequirementsManagementPage,
        },
        {
          id: uuidv4(),
          label: t("USER_MANAGEMENT"),
          link: RoutesString.UserManagementPage,
        },
        {
          id: uuidv4(),
          label: t("PERMISSION_MATRIX"),
          link: RoutesString.PermissionManagementPage,
        },
      ],
    },
  ];
};

const menuForMerchant = (pathname: string, t: (key: string) => string) => {
  const arrPath = pathname.split("/").slice(1);
  const getOpened = (root: string) => isEqual(arrPath[0], root);

  return [
    {
      id: uuidv4(),
      label: t("DASHBOARD"),
      icon: IconHome,
      iconActive: IconHome,
      root: "",
      initiallyOpened: getOpened(""),
      link: RoutesString.Dashboard,
    },
    {
      id: uuidv4(),
      label: t("ACCOUNT_AND_CARD"),
      icon: IconUser,
      iconActive: IconUser,
      root: "accounts",
      initiallyOpened: getOpened("accounts") || getOpened("cards"),
      links: [
        {
          id: uuidv4(),
          label: t("PAYMENT_SOURCE_ACCOUNT"),
          link: RoutesString.AccountsList,
          linkDetail: RoutesString.Accounts,
        },
        {
          id: uuidv4(),
          label: t("CARDS_LIST"),
          link: RoutesString.CardsList,
          linkDetail: RoutesString.Cards,
        },
      ],
    },
    {
      id: uuidv4(),
      label: t("TRANSFER_MONEY"),
      icon: IconCreditCard,
      iconActive: IconCreditCard,
      root: "hkd/transfer",
      initiallyOpened: false,
      link: RoutesString.HkdTransfer,
    },
    {
      id: uuidv4(),
      label: t("QR_COLLECTION"),
      icon: IconBarcode,
      iconActive: IconBarcode,
      root: "hkd/qr-payment",
      initiallyOpened: false,
      link: RoutesString.HkdQrPayment,
    },
    {
      id: uuidv4(),
      label: t("E_INVOICE"),
      icon: IconFileInvoice,
      iconActive: IconFileInvoice,
      root: "hkd/einvoice",
      initiallyOpened: false,
      link: RoutesString.HkdEInvoice,
    },
    {
      id: uuidv4(),
      label: t("GOV_PAYMENT"),
      icon: IconBuildingBank,
      iconActive: IconBuildingBank,
      root: "hkd/nsnn",
      initiallyOpened: getOpened("hkd/nsnn"),
      link: RoutesString.NopNsnnOverview,
      links: [
        {
          id: uuidv4(),
          label: t("DOMESTIC_TAX_PAYMENT"),
          link: RoutesString.HkdDomesticTax,
        },
        {
          id: uuidv4(),
          label: t("CUSTOMS_DUTY_PAYMENT"),
          link: RoutesString.CustomsDutyPaymentPage,
        },
        {
          id: uuidv4(),
          label: t("REGISTRATION_FEE"),
          link: RoutesString.HkdRegistrationFee,
        },
      ],
    },
    {
      id: uuidv4(),
      label: t("REPORT"),
      icon: IconChartBar,
      iconActive: IconChartBar,
      root: "hkd/report",
      initiallyOpened: false,
      link: RoutesString.HkdReport,
    },
    {
      id: uuidv4(),
      label: t("PAYMENT_SPEAKER"),
      icon: IconSpeakerphone,
      iconActive: IconSpeakerphone,
      root: "hkd/loa",
      initiallyOpened: false,
      link: RoutesString.HkdLoa,
    },
    {
      id: uuidv4(),
      label: t("NOTIFICATION"),
      icon: IconBell,
      iconActive: IconBell,
      root: "notifications",
      initiallyOpened: getOpened("notifications"),
      link: RoutesString.Notifications,
    },
    {
      id: uuidv4(),
      label: t("SERVICE_PACKAGE"),
      icon: IconPackage,
      iconActive: IconPackage,
      root: "hkd/package",
      initiallyOpened: false,
      link: RoutesString.HkdPackage,
    },
  ];
};

export { menuForMaker, menuForChecker, menuForMerchant };
